const mockData = {
  data: {
    contextItem: { path: '/sitecore/content/internet/home/static-page3', id: '15F3CD38755C525F916C8C4DFE010EE8' },
    datasourceItem: {
      // eslint-disable-next-line max-len
      path: '/sitecore/content/internet/home/static-page3/Page Components/static-page3-jss-staticpage-sections-BCF9D0F7-C09A-5113-8959-E8CE2B49CC98-0-NewsCarousel-6',
      id: '067B43655BBC51AB8CDAE11006E31F88',
      heading: { value: 'News' },
      anchor: { value: 'news' },
    },
    drsearch: {
      results: {
        items: [{
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE1',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Announces Sponsorship of Carnegie Initiative',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock1.png',
                  alt: 'hero1',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE2',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Announces Sponsorship of Carnegie Initiative',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock2.png',
                  alt: 'hero2',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE3',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Appoints Vice President, Marketing & Communications',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock3.png',
                  alt: 'hero3',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE4',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Driver Apprenticeship Program Launches in Michigan',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock4.png',
                  alt: 'hero4',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE5',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Announces Sponsorship of Carnegie Initiative',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock5.png',
                  alt: 'hero5',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE6',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Announces Sponsorship of Carnegie Initiative',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock6.png',
                  alt: 'hero6',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }, {
          item: {
            id: '15F3CD38755C525F916C8C4DFE010EE7',
            name: 'static-page3',
            path: '/sitecore/content/internet/home/static-page3',
            url: '/static-page3',
            pageTitle: { value: 'Static Page Sample 3' },
            heading: { value: 'Static Page Heading' },
            description: {
              value: 'Day & Ross Announces Sponsorship of Carnegie Initiative',
            },
            heroImage: {
              jss: {
                value: {
                  src: '/data/media/img/home/mock/mock7.png',
                  alt: 'hero',
                  width: '1450',
                  height: '334',
                },
              },
            },
          },
        }],
      },
    },
  },
};

export default mockData;
